module.exports = __webpack_public_path__ + "static/media/sidebar-2.32c8a148.jpg";